document.addEventListener('DOMContentLoaded', function() {
  // Toggle para móviles
  const toggleButton = document.querySelector('.mobile-menu-toggle');
  if (toggleButton) {
    toggleButton.addEventListener('click', function() {
      document.querySelector('.mega-menu__nav').classList.toggle('active');
    });
  }
  // Toggle para submenús e inframenús en móviles
  document.querySelectorAll('.menu-link').forEach(link => {
    link.addEventListener('click', function(e) {
      if (window.innerWidth <= 768) {
        e.preventDefault();
        const menuItem = this.parentElement;
        const menuHandle = menuItem.getAttribute('data-menu');
        const megaMenu = document.querySelector(`.mega-menu[data-menu="${menuHandle}"]`);
        if (megaMenu) {
          megaMenu.style.display = megaMenu.style.display === 'block' ? 'none' : 'block';
        }
      }
    });
  });
  // Toggle para inframenús en móviles
  document.querySelectorAll('.mega-menu__link').forEach(link => {
    link.addEventListener('click', function(e) {
      if (window.innerWidth <= 768) {
        e.preventDefault();
        const infraList = this.nextElementSibling;
        if (infraList && infraList.classList.contains('mega-menu__infralist')) {
          infraList.style.display = infraList.style.display === 'block' ? 'none' : 'block';
        }
      }
    });
  });
  // Hover para escritorio
  document.querySelectorAll('.menu-item').forEach(item => {
    item.addEventListener('mouseenter', function() {
      if (window.innerWidth > 768) {
        const menuHandle = this.getAttribute('data-menu');
        const megaMenu = document.querySelector(`.mega-menu[data-menu="${menuHandle}"]`);
        if (megaMenu) {
          document.querySelectorAll('.mega-menu').forEach(menu => menu.classList.remove('active'));
          megaMenu.classList.add('active');
        }
      }
    });
  });
  // Mantener el mega menú visible al entrar en él
  document.querySelectorAll('.mega-menu').forEach(menu => {
    menu.addEventListener('mouseenter', function() {
      if (window.innerWidth > 768) {
        this.classList.add('active');
      }
    });
    menu.addEventListener('mouseleave', function() {
      if (window.innerWidth > 768) {
        this.classList.remove('active');
      }
    });
  });
  // Cerrar todos los mega menús al salir de .custom-mega-menu
  const customMegaMenu = document.querySelector('.custom-mega-menu');
  customMegaMenu.addEventListener('mouseleave', function() {
    if (window.innerWidth > 768) {
      document.querySelectorAll('.mega-menu').forEach(menu => menu.classList.remove('active'));
    }
  });
});